import React from "react";
import { Card, Statistic, Typography, Grid } from "antd";
import {
  UserOutlined,
  SolutionOutlined,
  TeamOutlined,
  FileDoneOutlined,
  BookOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
const { Text } = Typography;
const { useBreakpoint } = Grid;
export const QuickStats = ({ stats, darkMode }) => {
  const screens = useBreakpoint();
  const statCards = [
    {
      title: "Learners",
      value: stats.totalLearners,
      icon: <UserOutlined />,
      color: "#9A6B0E",
      link: "/total-learners",
    },
    {
      title: "Managers",
      value: stats.totalManagers,
      icon: <SolutionOutlined />,
      color: "#9A6B0E",
      link: "/managers",
    },
    {
      title: "Mentors",
      value: stats.totalMentors,
      icon: <TeamOutlined />,
      color: "#9A6B0E",
      link: "/mentor",
    },
    {
      title: "Pending",
      value: stats.pendingTrainingRequests,
      icon: <FileDoneOutlined />,
      color: "#faad14",
    },
    {
      title: "Trainings",
      value: stats.inflightCount,
      icon: <BookOutlined />,
      color: "#52c41a",
    },
  ];
  const styles = {
    card: {
      borderRadius: 6,
      backgroundColor: darkMode ? "#1f1f1f" : "#fff",
      borderColor: darkMode ? "#303030" : "#f0f0f0",
      height: '100%',
      boxShadow: 'none'
    },
    secondaryTextColor: {
      color: darkMode ? "rgba(255, 255, 255, 0.45)" : "rgba(0, 0, 0, 0.45)",
    },
  };
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: screens.xs ? 'repeat(2, 1fr)' : screens.md ? 'repeat(5, 1fr)' : 'repeat(3, 1fr)',
      gap: '8px',
      marginBottom: '12px'
    }}>
      {statCards.map((stat, index) => {
        const cardContent = (
          <Card
            hoverable
            style={styles.card}
            styles={{ body: { padding: '12px' } }}
          >
            <Statistic
              title={<Text style={{
                ...styles.secondaryTextColor,
                fontSize: '13px'
              }}>{stat.title}</Text>}
              value={stat.value}
              prefix={stat.icon}
              valueStyle={{
                color: stat.color,
                fontSize: screens.xs ? '18px' : '20px'
              }}
            />
          </Card>
        );
        return stat.link ? (
          <Link key={index} to={stat.link} style={{ textDecoration: 'none' }}>
            {cardContent}
          </Link>
        ) : (
          <div key={index}>
            {cardContent}
          </div>
        );
      })}
    </div>
  );
};
QuickStats.propTypes = {
  darkMode: PropTypes.bool.isRequired,
  stats: PropTypes.shape({
    totalLearners: PropTypes.number.isRequired,
    totalManagers: PropTypes.number.isRequired,
    totalMentors: PropTypes.number.isRequired,
    pendingTrainingRequests: PropTypes.number.isRequired,
    inflightCount: PropTypes.number.isRequired,
    unreadMessages: PropTypes.number.isRequired,
  }).isRequired,
};